// extracted by mini-css-extract-plugin
export default {"ic":"styles_ic__qzB5P","subtitle":"styles_subtitle__g1bQ8"};